// ── CallRegister 결과/킵 chip + 모달 스타일 ───────────────────────────────────
// dark mode: rgba 반투명 배경 + 중간 채도 텍스트 색상으로 light/dark 공통 적용
// (light bg를 하드코딩하면 dark mode 카드 위에서 색상이 뜨거나 텍스트가 보이지 않음)

/** 결과 컬럼 - 계약완료 chip */
export const callResultContractedStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  background: 'rgba(22,163,74,0.13)',   // 반투명 초록 — light/dark 카드 위에서 모두 자연스러움
  color: '#16a34a',
  borderRadius: 999,
  padding: '2px 7px',
  fontSize: 11,
  fontWeight: 700,
  whiteSpace: 'nowrap',
};

/** 결과 컬럼 - 계약취소 chip */
export const callResultCancelledStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  background: 'rgba(217,119,6,0.13)',   // 반투명 앰버
  color: '#d97706',
  borderRadius: 999,
  padding: '2px 7px',
  fontSize: 11,
  fontWeight: 700,
  whiteSpace: 'nowrap',
};

/** 계약완료 행 결과 셀 - 날짜·상품·장수 소형 상세 텍스트 */
export const contractDetailTextStyle = {
  fontSize: 10,
  color: 'var(--success)',              // CSS 변수 — dark/light 동일하게 green 유지
  fontWeight: 600,
  whiteSpace: 'normal',
  lineHeight: 1.4,
};

/** 결과 컬럼 - 피드백 chip */
export const callResultFeedbackStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  background: 'rgba(99,102,241,0.13)',  // 반투명 인디고
  color: '#6366f1',
  borderRadius: 999,
  padding: '2px 7px',
  fontSize: 11,
  fontWeight: 600,
  whiteSpace: 'nowrap',
};

/** 결과 컬럼 - 피드백 메모 (chip 아래 추가 설명 텍스트)
 *  dark mode: var(--text-muted)=#4b5878 는 dark 배경에서 거의 안 보임 →
 *             var(--text-sub)=#9aa3c5 로 교체 */
export const callFeedbackMemoStyle = {
  display: 'block',
  fontSize: 10,
  color: 'var(--text-sub)',
  lineHeight: 1.4,
  marginTop: 2,
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-all',
};

/** 결과 컬럼 - 킵 chip (표시 전용) */
export const callKeepChipStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  background: 'rgba(245,158,11,0.13)',  // 반투명 앰버
  color: '#d97706',
  borderRadius: 999,
  padding: '2px 7px',
  fontSize: 11,
  fontWeight: 600,
  whiteSpace: 'nowrap',
};

/** 결과 컬럼 - ☆ 킵 chip (클릭 가능) */
export const callKeepChipClickableStyle = {
  ...callKeepChipStyle,
  border: 'none',
  cursor: 'pointer',
  lineHeight: 1,
};

/** 수정 모달 - 킵 등록 버튼 (앰버 아웃라인) */
export const editKeepBtnStyle = {
  width: '100%', border: '1px solid rgba(245,158,11,0.5)', borderRadius: 8,
  padding: '8px 12px', fontSize: 13, fontWeight: 600,
  background: 'rgba(245,158,11,0.08)', color: '#d97706', cursor: 'pointer',
};

/** 수정 모달 - 킵됨 상태 버튼 (앰버 solid) */
export const editKeepActiveBtnStyle = {
  width: '100%', border: '1px solid rgba(245,158,11,0.7)', borderRadius: 8,
  padding: '8px 12px', fontSize: 13, fontWeight: 700,
  background: 'rgba(245,158,11,0.15)', color: '#d97706', cursor: 'pointer',
};

// ── 킵 해제 모달 스타일 ───────────────────────────────────────────────────────

/** 킵 해제 모달 - 레이블 */
export const keepReleaseLabel = {
  fontSize: 12,
  color: 'var(--text-sub)',
  fontWeight: 700,
};

/** 킵 해제 모달 입력 필드 */
export const keepReleaseFieldStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '7px 9px',
  height: 34,
  fontSize: 12,
  width: '100%',
  boxSizing: 'border-box',
  color: 'var(--text)',
  background: 'var(--bg-card)',
  display: 'block',
};

/** 킵 해제 모달 - 방문 취소 버튼 */
export const keepReleaseCancelBtnStyle = {
  border: '1px solid #fca5a5',
  background: 'var(--bg-card)',
  color: '#dc2626',
  borderRadius: 8,
  padding: '9px 12px',
  fontSize: 13,
  fontWeight: 600,
  cursor: 'pointer',
  width: '100%',
  textAlign: 'center',
};
